import { ONE_MEBIBYTE } from '@lucidlink/uicore';
import { bigIntMin } from '#context/file-contexts-common';
export const optimizeRangeIntoChunks = (start, end, chunkSize = BigInt(ONE_MEBIBYTE)) => {
    if (start >= end) {
        return [];
    }
    const chunks = [];
    let currentStart = start;
    const exclusiveEnd = end;
    if (currentStart < exclusiveEnd) {
        let firstChunkEnd;
        if (currentStart % chunkSize !== 0n) {
            const nextBoundary = (currentStart / chunkSize + 1n) * chunkSize;
            firstChunkEnd = bigIntMin(nextBoundary, exclusiveEnd);
        }
        else {
            firstChunkEnd = bigIntMin(currentStart + chunkSize, exclusiveEnd);
        }
        chunks.push({ start: currentStart, end: firstChunkEnd });
        currentStart = firstChunkEnd;
    }
    while (currentStart < exclusiveEnd) {
        const currentEnd = bigIntMin(currentStart + chunkSize, exclusiveEnd);
        chunks.push({ start: currentStart, end: currentEnd });
        currentStart = currentEnd;
    }
    return chunks;
};
